export type InfiniteArray<T> = (T | InfiniteArray<T>)[];
